import React from "react";
import OrderVisor from "../OrderVisor";
import { correctArrayOrdered } from "../../../core/visor/correction_functions";

/* eslint-disable react/prop-types */

export function Ordering() {
  return {
    init: function () {
      // eslint-disable-next-line  no-new
      // new sortable();
    },
    getRenderTemplate: function (state, props) {
      return <OrderVisor state={state} props={props} />;
    },
    checkAnswer(current, correct, state) {
      // ponytail: currentAnswer starts as `false` (getConfig defaultCurrentAnswer)
      // and stays non-array if the mount seed never ran (stale bundle, restored
      // legacy state). Spreading a boolean threw and killed Check Answer on the
      // shared-link visor — an unanswered ordering is simply score 0.
      if (!Array.isArray(current)) return 0;
      let correct2 = [...current].sort();
      return correctArrayOrdered(current, correct2, state.nBoxes, state.allowPartialScore);
    },
  };
}
/* eslint-enable react/prop-types */
